const moment = require("moment")

export default new (class {
  timestampToDate(timestamp) {
    return new Date(new Date(timestamp * 1000)).toLocaleDateString("de-CH")
  }

  timestampToTime(timestamp) {
    timestamp = parseInt(timestamp)

    let hours = new Date(timestamp * 1000).getHours()

    let minutes = new Date(timestamp * 1000).getMinutes()
    if (minutes < 10) {
      minutes = "0" + minutes
    }
    let value = hours + ":" + minutes
    return value
  }
  timestampToDay(timestamp) {
    return moment(timestamp * 1000).format("D")
  }

  // NEU: Funktion für den Monat (z.B. "Jun")
  timestampToMonth(timestamp) {
    // 'de-CH' für deutsche Monatskürzel (z.B. Jun, Okt, Dez)
    return moment(timestamp * 1000)
      .locale("de-CH")
      .format("MMM")
  }
  getCourseEndTime(course) {
    let endTime = moment()
    endTime.set({
      hours: course.hours,
      minutes: course.minutes,
      seconds: 0,
      miliseconds: 0,
    })

    endTime.add(course.duration, "minutes")
    return endTime.format("LT")
  }

  getCourseStartTime(course) {
    let startTime = moment()
    startTime.set({
      hours: course.hours,
      minutes: course.minutes,
      seconds: 0,
      miliseconds: 0,
    })

    return startTime.format("LT")
  }
})()
